import colorsets from './colorsets';

/**
 * getDataFromCanvas
 * @param {*} canvas 
 */
export default function getDataFromCanvas(canvas, step, width, height, depth, colorset, random) {
    
    const colors = [];
    const positions = [];
    const ctx = canvas.getContext('2d');
    const toggleOffset = (step/canvas.width)/2;

    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;

    let toggleRow = false;
    for(let y=0; y<canvas.height-step; y += step) {
        for(let x=0; x<canvas.width-step; x += step) {
            const result = readXY(x, y);
            if(!result) continue;
            positions.push( ...result.xyz );
            colors.push( ...result.rgb );
        }
        toggleRow = 1 - toggleRow;
    }

    return { positions, colors };


    function readXY(x, y) { 
        let i = (x + (y * canvas.width)) * 4;
                
        const r = data[i];
        const g = data[i+1];
        const b = data[i+2];
        
        const v = g; //(r+g+b)/3
        if(v < 8) return false;

        let _x = x/canvas.width * 2 - 1;
        let _y = y/canvas.height * -2 + 1;
        let _z = v/255;
    
        //offset every 2nd row
        if(toggleRow) {
            _x += toggleOffset;
        } else {
            _x -= toggleOffset;
        }
    
        let rgb = colorsets[colorset](_x, _y, v, r, g, b);

        _x *= width;
        _y *= height;
        _z *= depth;
    
        if(random) {
            _x += (Math.random()-0.5) * 2 * random;
            _y += (Math.random()-0.5) * 2 * random;
            _z += (Math.random()-0.5) * 2 * random;
        }

        return {
            xyz: [_x, _y, _z],
            rgb: rgb
        }
    }
}